import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/(company)/contact/page.jsx");
